export default __webpack_public_path__ + "static/media/hht1_ep4_minisitcom_02.dfa0e991.png";